import React from "react";
import "./ExtraCredit/extraCredit.css";
import ExtraCreditResultsModal from "./extra_credit_results_modal";
import Config from '../../config';
import determineIfAllExtraCreditComplete from "./objects/determine_if_all_extra_credit_complete";

class ExtraCreditMain extends React.Component {
    
    constructor(props) { 
        super(props);
       
        this.gameInfo = this.props.gameInfo();
        props.onOpen();
        this.state = {
            openExtraCreditResultsModal: false,
            subProcess: "ExtraCreditMain",
            environment: Config.dataURL.currentEnv,
        }
        this.allCompleteText = "";
        this.setDisplayText();
    }
   
    render() {
                                                        
    return <>
        <div className="col-8">
        <div className="card mb-0 rounded-corners-lg height-max">
            <button className="pages-back-button ml-4 mt-4" 
                onClick ={()=> this.props.goBack()}>
                                    Back
            </button>
            <h3 className="mt-0 text-center">Extra Credit</h3>
            <h5 className="text-center">Main Page</h5>
            <span className="mt-2 ml-4 mr-4">
            <div className="mx-4">This area allows you to learn about some basic financial literacy 
                 concepts.  If you can successfully complete the challenges, you 
                 will be able to earn dollars to increase the amount of your
                 game cash and salary. </div>
           
                    <div className="m-0 p-0 text-center">
                    {!this.gameInfo.gameExists && this.props.playerRole === "player" ?
                        <div className="mt-3 mx-4 text-left">
                        You have not yet completed the Getting Started part of the game.  Not to worry....Any dollars 
                        that you earn by doing the extra credit challenges now, will be added to your game once you
                        finish the Getting Started part of the game.  To complete the Getting Started part of the 
                        game return to the main (home) page and click on "Game" square.</div>
                    :
                        <div></div>
                    }
            
                    {this.gameInfo.extraCreditExists ?
                                                  
                        <div className="text-center">
                            <button className="good-looking-button-extraCredit mt-4" 
                                onClick ={()=> this.openResultsModal()}>
                                Review Extra Credit Amounts 
                            </button>
                        </div>
                    :
                        <div className="mt-2">You have not completed any of the extra credit processes at this point.</div>       
                    }

                    {this.allCompleteText !== "" ?
                        <span>
                            <h6 className="mt-3 text-center font-weight-bold">Congratulations!</h6>  
                            <h6>{this.allCompleteText}</h6> 
                            <div className="mt-4"></div>
                            {this.gameInfo.gameExists ?
                                <button className="good-looking-button-extraCredit" onClick ={()=>this.goToMainPage()}>
                                    Go To the Game</button> 
                            :
                                null
                            }
                        </span>
                    :
                        <div className="font-weight-bold mt-4">Click on a button (topic) to the right to continue. </div>
                    }
                    
                    {this.state.openExtraCreditResultsModal ?
                        <ExtraCreditResultsModal show={this.state.openExtraCreditResultsModal} 
                            gameInfo = {() => this.props.gameInfo()}
                            onClose={() => this.closeResultsModal()} 
                        />
                    :
                        <div></div>
                    }
                </div>
            </span>
            </div>
                 
        </div>
     
     </>
    }

    
componentDidMount()
{
    let playerRole = sessionStorage.getItem("userRole");
    this.props.setGameInfo(playerRole, 'playerRole');
    sessionStorage.removeItem("GameViewSubProcess");
}

setDisplayText(){
    let allExtraCreditComplete = false;
    if (this.gameInfo.extraCredit.user ){
        allExtraCreditComplete = determineIfAllExtraCreditComplete(this.gameInfo.extraCredit.extraCreditTable);
    }
  
    if (allExtraCreditComplete === true){
        this.allCompleteText = "You have completed all of the extra credit challenges.";
    }else {
        const checkComplete = sessionStorage.getItem("extraCreditChallengeCompleted");
        if (checkComplete !== null){
            this.openResultsModal();
            sessionStorage.removeItem("extraCreditChallengeCompleted");
        }
    } 
}

goToMainPage(){
    this.props.onNavigate("game-board");

}

openResultsModal(){
    this.setState({openExtraCreditResultsModal: true});
}

closeResultsModal(){
    this.setState({openExtraCreditResultsModal: false});
}

}


export default ExtraCreditMain;